export const thingsToLearn:string[] = [
    'Space', 'Animals', 'Weather', 'Chemistry', 'Sound', 'Movement', 'Electricity', 'Music', 'Temperature',
                         'Health', 'Engineering', 'Investigating', 'Facts', 'Color', 'Biology', 'Seasons', 'Plants', 'Nature',
                         'Technology', 'Food', 'Art', 'Light', 'Reactions', 'Air', 'Machines', 'Predictions', 'Illusions', 'Building',
    'Structures', 'Earth', 'Rocks'
]


      export const initial_interests =  ['Ride her bike', 'Play at the beach', 'Camping', 'Hiking', 'Play outside', 'Swimming',
                           'Animals', 'Marine life', 'Pets', 'Birds', 'Unicorns', 'Mythical creatures']